import {
  Button,
  Form,
  FormField,
  Header,
  Input,
  Modal,
  SpaceBetween,
  Grid,
  DatePicker,
  TimeInput,
  Checkbox,
  Box,
} from "@cloudscape-design/components";
import React, { useEffect, useState } from "react";
import ConfirmationModal from "./ConfirmationModal";
import moment from "moment";
import { regExpAll, isEmpty } from "../components/utils";
import { useDispatch, useSelector } from "react-redux";
import { updateLookup } from "../../redux/actions/lookups";

const EditLookupModal = () => {
  ///////////////
  // INITIALIZE
  ///////////////

  const [value, setValue] = useState({});
  const [inputError, setInputError] = useState({});
  const Config = useSelector((state) => state.config);
  const modal = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  useEffect(() => {
    setInputError({});
    setValue({
      ...modal.item,
    });
  }, [modal.item, Config]);

  //////////////////
  // FORM HANDLING
  //////////////////

  const validateInputs = (newValue) => {
    let errors = {};

    if (!/^\d+$/.test(newValue.eventDays)) {
      errors.DURATION = "Invalid number of days. Please enter a valid number.";
    } else {
      if (parseInt(newValue.eventDays) > Config.EVENT_MAX_DAYS) {
        errors.DURATION =
          "Number of days exceeds maximum value of " +
          Config.EVENT_MAX_DAYS +
          ".";
      }
    }

    if (!/^\d+$/.test(newValue.eventHours)) {
      errors.DURATION = "Invalid number of hours. Please enter a valid number.";
    } else {
      if (parseInt(newValue.eventHours) > 23) {
        errors.DURATION =
          "Number of hours exceeds maximum value of 23 hrs. Please add another days if you need a longer event duration.";
      }
    }

    if (!/^\d+(\.\d+)*$/.test(newValue.eventBudget)) {
      errors.BUDGET = "Invalid budget. Please enter a valid decimal value.";
    } else {
      if (parseFloat(newValue.eventBudget) > Config.ACCOUNT_MAX_BUDGET) {
        errors.BUDGET =
          "Budget amount exceeds maximum value of " +
          Config.ACCOUNT_MAX_BUDGET +
          ".";
      }
    }

    if (!/^\d+$/.test(newValue.maxAccounts)) {
      errors.ACCOUNTS =
        "Invalid number of AWS accounts. Please enter a valid number.";
    } else {
      if (parseInt(newValue.maxAccounts) > Config.EVENT_MAX_ACCOUNTS) {
        errors.ACCOUNTS =
          "Number of AWS accounts exceeds maximum value of " +
          Config.EVENT_MAX_ACCOUNTS +
          ".";
      }
    }

    let eventDate = moment(
      newValue.eventDateInput + " " + newValue.eventTimeInput,
      "YYYY/MM/DD hh:mm"
    );
    if (!eventDate.isValid()) {
      errors.DATE =
        "Unable to parse event date correctly. Please check for invalid date.";
    } else {
      if (
        eventDate
          .add(newValue.eventDays, "days")
          .add(newValue.eventHours, "hours")
          .isSameOrBefore(moment())
      ) {
        errors.DATE =
          "Event termination timestamp (i.e. event date plus duration) has to be in the future.";
      }
    }

    setInputError(errors);
    return isEmpty(errors);
  };

  const updateFormValue = (update) => {
    setValue((prev) => {
      let newValue = { ...prev, ...update };
      //   validateInputs(newValue);
      return newValue;
    });
  };

  const submit = () => {
    let newValue = value;
    // if (!validateInputs(newValue)) {
    //   return;
    // }
    newValue.ModifiedOn = moment().unix();
    dispatch({ type: "modal/dismiss" });
    dispatch(updateLookup(newValue));
  };

  ////////////////////
  // MODAL COMPONENT
  ////////////////////

  return (
    <>
      <Modal
        onDismiss={() => dispatch({ type: "modal/dismiss" })}
        visible={modal.status === "editLookup"}
        closeAriaLabel="Close"
        size="large"
        header={<Header variant="h1">Edit lookup "{value.lookupkey}"</Header>}
      >
        <Form
          actions={
            <SpaceBetween direction="horizontal" size="xs">
              <Button
                variant="link"
                onClick={() => dispatch({ type: "modal/dismiss" })}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => submit()}
                disabled={!isEmpty(inputError)}
              >
                Save
              </Button>
            </SpaceBetween>
          }
        >
          <SpaceBetween direction="vertical" size="l">
            <FormField label="Lookup name" description="This is Lookup Key.">
              <Input value={value.lookupkey} disabled />
            </FormField>
            <FormField
              label="Lookup Value"
              description="This is Lookup Value. For pipeline status: SUCCESS or PENDING"
            >
              <input
                type="text"
                onChange={(event) =>
                  updateFormValue({ lookupvalue: event.target.value })
                }
                value={value.lookupvalue}
              />
            </FormField>
          </SpaceBetween>
        </Form>
      </Modal>
    </>
  );
};

export default EditLookupModal;
